import { createContext } from 'react'

type StringFieldKey =
  | 'companyName'
  | 'website'
  | 'location'
  | 'yearFounded'
  | 'dunsNumber'
  | 'country'
  | 'region'
  | 'parentCompanyName'
  | 'description'

type BoolFieldKey = 'isPublic' | 'isSubsidiary'

type TouchableKey = 'website' | 'yearFounded' | 'dunsNumber'

export type GeneralInfoFormState = {
  /** user-editable */
  companyName: string
  website: string
  location: string
  yearFounded: string
  dunsNumber: string
  parentCompanyName: string
  description: string
  logoId: string | null
  isPublic: boolean
  isSubsidiary: boolean
  /** derived from google places, not directly edited */
  countryCode: string | null
  country: string
  region: string
  latitude: string | null
  longitude: string | null
  /**
   * blur-tracking so format errors only show after the field has been
   * visited once.
   */
  websiteTouched: boolean
  yearFoundedTouched: boolean
  dunsNumberTouched: boolean
  /** server-side submit failure to surface inline */
  submitError: string | null
}

export type GeneralInfoFormAction =
  | { type: 'setString'; field: StringFieldKey; value: string }
  | { type: 'setBool'; field: BoolFieldKey; value: boolean }
  | { type: 'setLogoId'; value: string | null }
  | { type: 'touch'; field: TouchableKey }
  | {
      type: 'addressPicked'
      countryCode: string | null
      country: string
      region: string
      latitude: string | null
      longitude: string | null
    }
  | { type: 'addressInvalidated' }
  | { type: 'submitError'; message: string | null }

export type GeneralInfoDerived = {
  yearFoundedInt: number | null
  yearFoundedInvalid: boolean
  dunsNumberInvalid: boolean
  websiteInvalid: boolean
  locationUnresolved: boolean
  isValid: boolean
  currentYear: number
}

export type GeneralInfoFormContextValue = {
  state: GeneralInfoFormState
  derived: GeneralInfoDerived
  dispatch: React.Dispatch<GeneralInfoFormAction>
  isSubmitting: boolean
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export const GeneralInfoFormContext =
  createContext<GeneralInfoFormContextValue | null>(null)
